import { ICourse, IProgram } from './ISearchService';
import ActionTracker, { ITrackEvent, IAnalyticsMethods } from './ActionTracker';
import Router from 'vue-router';

/*
 Overriding the 1-class-per-file rule because dozens of tiny files
 does not feel more maintainable for this case.
 */

/* tslint:disable:max-classes-per-file */

// TODO:TRS Determine what should be different between courses and programs

class ExitDialogEvent implements ITrackEvent {
	constructor (public router: Router) { }

	public track (va: IAnalyticsMethods): void {
		va.page(this.router.currentRoute.fullPath);
	}
}

export class TransitionEvent implements ITrackEvent {
	constructor (public program: IProgram | ICourse) { }
	public track (va: IAnalyticsMethods): void {
		va.event('transition', this.program.institutionName, this.program.title, 1);
	}
}

export class ExpandEvent implements ITrackEvent {
	constructor (public program: IProgram | ICourse) { }

	public track (va: IAnalyticsMethods): void {
		va.page(`/virtual/details/${this.program.institutionName}/${this.program.title}`);
	}
}

export class CollapseEvent extends ExitDialogEvent {
	constructor (public program: IProgram | ICourse, public router: Router) {
		super(router);
	}

	public track (va: IAnalyticsMethods): void {
		va.page(this.router.currentRoute.fullPath);
		super.track(va);
	}
}

export class AddFavoriteEvent implements ITrackEvent {
	constructor (public program: IProgram | ICourse) { }

	public track (va: IAnalyticsMethods): void {
		va.event('favorite', 'add', `${this.program.institutionName}/${this.program.title}`, 1);
	}
}

export class OpenRmiEvent implements ITrackEvent {
	constructor (public program: IProgram | ICourse) { }

	public track (va: IAnalyticsMethods): void {
		va.event('requestInfo', 'startRequest', this.program.institutionName, 1);
		va.page(`/virtual/requestinfo/${this.program.institutionName}/${this.program.title}`);
	}
}

export class CloseRmiEvent extends ExitDialogEvent {
	constructor (public program: IProgram | ICourse, public router: Router) {
		super(router);
	}

	public track (va: IAnalyticsMethods): void {
		super.track(va);
	}
}

export class SendRmiEvent extends ExitDialogEvent {
	constructor (public program: IProgram | ICourse, public router: Router) {
		super(router);
	}

	public track (va: IAnalyticsMethods): void {
		va.event('requestInfo', 'sendRequest', this.program.institutionName, 1);
		super.track(va);
	}
}

export class OpenFavoritesEvent implements ITrackEvent {
	constructor (public count: number) { }

	public track (va: IAnalyticsMethods): void {
		if (this.count) {
			va.page('/virtual/favorites/manage');
		} else {
			va.page('/virtual/favorites/manage/empty');
		}
	}
}

export class CloseFavoritesEvent extends ExitDialogEvent {
	constructor (public router: Router) {
		super(router);
	}

	public track (va: IAnalyticsMethods): void {
		super.track(va);
	}
}

export class OpenCompareEvent implements ITrackEvent {
	constructor (public count: number) { }

	public track (va: IAnalyticsMethods): void {
		va.event('favorites', 'startEmail', '', 1);
		va.page('/virtual/favorites/compare');
	}
}

export class CloseCompareEvent implements ITrackEvent {
	public track (va: IAnalyticsMethods): void {
		va.page('/virtual/favorites/manage');
	}
}

export class OpenEmailProgramsEvent implements ITrackEvent {
	public track (va: IAnalyticsMethods): void {
		va.event('favorites', 'startEmail', '', 1);
		va.page('/virtual/favorites/email');
	}
}

export class CloseEmailProgramsEvent implements ITrackEvent {
	public track (va: IAnalyticsMethods): void {
		va.page('/virtual/favorites/manage');
	}
}

export class SendEmailProgramsEvent implements ITrackEvent {
	constructor (public count: number) { }

	public track (va: IAnalyticsMethods): void {
		va.event('favorites', 'sendEmail', '', this.count);
		va.page('/virtual/favorites/manage');
	}
}

export class OpenPrintFavoritesEvent implements ITrackEvent {
	public track (va: IAnalyticsMethods): void {
		va.event('favorites', 'print', '', 1);
	}
}

export class OpenSearchPrintEvent implements ITrackEvent {
	public track (va: IAnalyticsMethods): void {
		va.event('search', 'print', '', 1);
	}
}

export class PrintEvent implements ITrackEvent {
	constructor (public style: string, public columnCount: number, public includeDescription: boolean) { }

	public track (va: IAnalyticsMethods): void {
		if ((this.style || '').toLowerCase() === 'grid') {
			const desc = `${this.style}:${this.columnCount}:${this.includeDescription}`;
			va.event('print', desc, '', 1);
		} else {
			va.event('print', this.style, '', 1);
		}
	}
}

export class OpenSearchGridEvent implements ITrackEvent {
	public track (va: IAnalyticsMethods): void {
		va.event('search', 'grid', '', 1);
		va.page('/virtual/search/grid');
	}
}

export class CloseSearchGridEvent extends ExitDialogEvent {
	constructor (public router: Router) {
		super(router);
	}

	public track (va: IAnalyticsMethods): void {
		super.track(va);
	}
}

export class FacetSelectedEvent implements ITrackEvent {
	constructor (public category: string, public value: string) { }

	public track (va: IAnalyticsMethods): void {
		va.event(`facet:${this.category}`, this.value, '', 1);
	}
}

// Exporting the tracker for convenience, tracker and events can be imported from one file
export default ActionTracker;
